import { Badge } from '../badge/badge.interface';
import { TextComponentConfig } from '../text/text-component-config.interface';

export interface CardElevenItem {
    badge?: Badge;
    text?: TextComponentConfig;
}
